import type { Command, ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import {
	getParameters,
	setParameter,
	type NativeEmbedParameters,
} from '@atlaskit/native-embeds-common';

import type { EditorPluginNativeEmbedsPlugin } from '../../nativeEmbedsPluginType';
import { pluginKey } from '../plugin-state';

import type { NativeEmbedResizeCommandOpts } from './types';

export const getWidth = (selectedNode: PMNode): number | undefined => {
	return getParameters(selectedNode.attrs.parameters, 'width');
};

export const createUpdateWidthCommand =
	(
		api: ExtractInjectionAPI<EditorPluginNativeEmbedsPlugin> | undefined,
		width: number,
		selectedNode: PMNode,
		height?: number,
		opts?: NativeEmbedResizeCommandOpts,
	): Command =>
	() => {
		const { isMaxWidth = false, ...docUpdateOpts } = opts ?? {};
		api?.extension?.actions?.api()?.doc?.update(
			selectedNode.attrs.localId,
			(current) => {
				const params = current.attrs?.parameters as NativeEmbedParameters | undefined;
				let updatedParams = setParameter(params, { width });
				updatedParams = setParameter(updatedParams, { isMaxWidth });
				if (height !== undefined) {
					updatedParams = setParameter(updatedParams, { height });
				}
				return {
					attrs: {
						...current.attrs,
						parameters: updatedParams,
					},
				};
			},
			docUpdateOpts,
		);

		return true;
	};

export const setResizingState =
	(isResizing: boolean, width?: number): Command =>
	(state, dispatch) => {
		if (dispatch) {
			const tr = state.tr;
			tr.setMeta(pluginKey, { type: 'SET_RESIZING', isResizing, width });
			tr.setMeta('scrollIntoView', false);
			dispatch(tr);
		}
		return true;
	};
